import { render, staticRenderFns } from "./WalletStatus.vue?vue&type=template&id=1539fa7b"
import script from "./WalletStatus.vue?vue&type=script&lang=js"
export * from "./WalletStatus.vue?vue&type=script&lang=js"
import style0 from "./WalletStatus.vue?vue&type=style&index=0&id=1539fa7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports